<template>
  <div class="propertyTemplate">
    <el-card>
      <el-page-header @back="goBack" :content="title"></el-page-header>
    </el-card>
    <main class="content">
      <el-card>
        <el-form :inline="true" :model="searchForm">
          <el-form-item label="值">
            <el-input v-model="searchForm.value" placeholder="值" clearable></el-input>
          </el-form-item>
          <el-form-item label="描述">
            <el-input v-model="searchForm.name" placeholder="描述" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSearch">查询</el-button>
          </el-form-item>
        </el-form>
        <el-table stripe :data="tableData" v-loading="loading" style="width: 100%">
          <el-table-column prop="value" label="值" width="300"></el-table-column>
          <el-table-column prop="description" label="描述"></el-table-column>
          <el-table-column label="操作" width="250" align="right">
            <template slot="header">
              <el-button type="primary" size="mini" @click="handleCreate">添加</el-button>
            </template>
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="handleEdit(scope.$index, scope.row)">编辑信息</el-button>
              <el-divider direction="vertical" ></el-divider>
              <el-button type="text" size="mini" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: center;padding-top: 20px">
          <el-pagination
            background
            layout="sizes,prev, pager, next"
            :page-sizes="[10, 20, 50, 100]"
            v-if="total>0"
            :total="total"
            :page-size="pageSize"
            @size-change="handleSizeChange"
            @current-change="onPageChange"
            @prev-click="onPageChange"
            @next-click="onPageChange"
          ></el-pagination>
        </div>
      </el-card>
    </main>
    <el-dialog title="属性值" :visible.sync="editDialogVisible" width="700px">
      <el-form :model="editForm" label-width="80px">
        <el-form-item label="值">
          <el-input v-model="editForm.value" placeholder="请输入值" clearable></el-input>
        </el-form-item>
        <el-form-item label="描述">
          <el-input v-model="editForm.description" placeholder="请输入描述" clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="onSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      title: (this.unit == "" || this.unit == undefined) ? "属性值" : "属性值(" + this.unit + ")",
      searchForm: {
        propertyId: this.propertyId,
        value: "",
        description: ""
      },
      loading: false,
      total: 0,
      pageSize: 10,
      currentPage: 1,
      tableData: [],
      editDialogVisible: false,
      editForm: {
        id: "",
        propertyId: this.propertyId,
        description: "",
        value: ""
      },
    };
  },
  props: ["propertyId", "unit"],
  methods: {
    onSearch() {
      this.loading = true;
      let _this = this;
      let params = {
        propertyId: this.propertyId
      };
      if (this.searchForm.value != "") {
        params["value"] = this.searchForm.value;
      }
      if (this.searchForm.description != "") {
        params["description"] = this.searchForm.description;
      }
      this.$axios
        .post("/admin/property/value/search", {
          cond: params,
          page: this.currentPage - 1,size:this.pageSize
        })
        .then(function(response) {
          let resp = response.data;
          if (resp.header.status == 0) {
            _this.loading = false;
            _this.tableData = resp.data.content;
            _this.total = resp.data.totalElements;
          }
        })
        .catch(function(error) {});
    },
    handleCreate() {
      this.editForm.id = "";
      this.editForm.description = "";
      this.editForm.value = "";
      this.editDialogVisible = true;
    },
    onSubmit() {
      let _this = this;
      this.$axios
        .post("/admin/property/value", this.editForm)
        .then(function(response) {
          let resp = response.data;
          if (resp.header.status == 0) {
            _this.$notify({
              title: "成功",
              message: "数据保存成功",
              type: "success"
            });
            _this.editDialogVisible = false;
            _this.onSearch();
          } else {
            _this.$notify.error({
              title: "错误",
              message: resp.header.msg
            });
          }
        });
    },
    handleSizeChange(pageSize){
      this.pageSize = pageSize;
      this.onSearch();
    },
    onPageChange(currentPage) {
      this.currentPage = currentPage;
      this.onSearch();
    },
    handleEdit(index, row) {
      this.editForm.id = row.id;
      this.editForm.value = row.value;
      this.editForm.description = row.description;
      this.editDialogVisible = true;
    },
    handleDelete(index, row) {
      let _this = this;
      this.$confirm("是否删除属性模板【" + row.value + "】？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "删除",
        cancelButtonText: "取消"
      }).then(() => {
        _this.$axios
          .delete("/admin/property/value/delete/" + row.id)
          .then(function(response) {
            let resp = response.data;
            if (resp.header.status === 0) {
              _this.$notify({
                title: "成功",
                message: "数据删除成功",
                type: "success"
              });
              _this.onSearch();
            } else {
              _this.$notify.error({
                title: "错误",
                message: resp.header.msg
              });
            }
          });
      });
    },
    goBack() {
      this.$router.go(-1);
    }
  },
  created() {
    this.onSearch();
  }
};
</script>
<style>
</style>